import { css } from '@emotion/react';
import { transition } from '~/styles/transition';

export const h1 = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.black};
    line-height: 1.58;
    font-size: clamp(2.8rem, ${(58 / theme.layout.fontComp) * 100}vw, 6.8rem);
`;

export const h2 = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.black};
    line-height: 1.325;
    font-size: clamp(2.4rem, ${(40 / theme.layout.fontComp) * 100}vw, 5rem);
`;

export const h3 = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.black};
    line-height: 1.26;
    font-size: clamp(2.2rem, ${(34 / theme.layout.fontComp) * 100}vw, 4.6rem);
`;

export const h4 = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.medium};
    line-height: 1.34;
    color: ${theme.colors.text.black};
    font-size: clamp(1.8rem, ${(26 / theme.layout.fontComp) * 100}vw, 3.4rem);
`;

export const h5 = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1.09;
    color: ${theme.colors.text.black};
    font-size: clamp(1.6rem, ${(22 / theme.layout.fontComp) * 100}vw, 2.8rem);
`;

export const p = ({ theme }) => css`
    font-family: ${theme.fonts.body};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1.22;
    color: ${theme.colors.text.black};
    font-size: clamp(1.8rem, ${(22 / theme.layout.fontComp) * 100}vw, 2.4rem);
`;

export const small = ({ theme }) => css`
    font-family: ${theme.fonts.body};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1.09;
    font-size: clamp(1.2rem, ${(14 / theme.layout.fontComp) * 100}vw, 1.8rem);
`;

export const medium = ({ theme }) => css`
    font-family: ${theme.fonts.body};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1.22;
    font-size: clamp(1.8rem, ${(22 / theme.layout.fontComp) * 100}vw, 2.4rem);
`;

export const large = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.medium};
    line-height: 1.3;
    font-size: clamp(1.6rem, ${(26 / theme.layout.fontComp) * 100}vw, 3.4rem);
`;

export const eyebrow = ({ theme }) => css`
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.black};
    line-height: 1.09;
    text-transform: uppercase;
    font-size: clamp(1.6rem, ${(20 / theme.layout.fontComp) * 100}vw, 2.4rem);
`;

export const a = ({ theme }) => css`
    ${transition({}, 'color')};
    text-decoration: underline;
    color: ${theme.colors.text.blue};

    &:hover,
    &:focus {
        color: ${theme.colors.text.black};
    }
`;

export const ul = ({ theme }) => css`
    list-style-type: disc;
    margin: 1rem 0 2rem;
    padding-left: 2em;
`;

export const ol = ({ theme }) => css`
    list-style-type: decimal;
    margin: 1rem 0 2rem;
    padding-left: 2em;
`;

export const li = ({ theme }) => css`
    ${medium({ theme })};

    &:not(:last-of-type) {
        margin-bottom: 10px;
    }
`;

export const label = ({ theme, size = 'regular' }) => css`
    font-family: ${theme.fonts.body};
    font-weight: 400;
    font-size: ${size === 'large' ? '2.0rem' : '1.6rem'};
    line-height: 1.09;

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        font-size: ${size === 'large' ? '2.2rem' : '1.8rem'};
    }
`;

export const error = ({ theme, size = 'normal' }) => css`
    font-family: ${theme.fonts.heading};
    font-size: ${size === 'normal' ? '1.3rem' : '1.6rem'};
    line-height: 1.09;
    font-weight: 500;

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        font-size: ${size === 'normal' ? '1.4rem' : '1.8rem'};
    }
`;
